import { render } from "./RCI.vue?vue&type=template&id=68fc494d&scoped=true"
import script from "./RCI.vue?vue&type=script&lang=js"
export * from "./RCI.vue?vue&type=script&lang=js"

import "./RCI.vue?vue&type=style&index=0&id=68fc494d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68fc494d"]])

export default __exports__